import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import PrivatePageSF from '../../templates/PrivatePageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import LRTableBodyUI from '../../widgets/layout/LRTableBodyUI'
import ViewOrUpdateSF from '../../widgets/layout/ViewOrUpdateSF'
import NameViewUI from '../../components/userSettings/NameViewUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import EmailViewUI from '../../components/userSettings/EmailViewUI'
import LRTableRowLinkUI from '../../widgets/layout/LRTableRowLinkUI'
import NameUpdateSF from '../../components/userSettings/NameUpdateSF'
import AvatarViewUI from '../../components/userSettings/AvatarViewUI'
import AvatarInfoUI from '../../components/userSettings/AvatarInfoUI'
import EmailUpdateSF from '../../components/userSettings/EmailUpdateSF'
import PasswordViewUI from '../../components/userSettings/PasswordViewUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import PasswordUpdateSF from '../../components/userSettings/PasswordUpdateSF'
import PasswordExternalUI from '../../components/userSettings/PasswordExternalUI'
import './UserSettingsPage.css'

const UserSettingsPrjPageUI = ({context, user, paymentCard, messageList, errorList,
    onEmailUpdated, onNameUpdated, onEmailAcceptanceUpdated
  }) =>

  <PrivatePageSF context={context} className='pg_user_st_prj' backLink='/settings' centered={!user}
      messageList={messageList} headerMessageKey='c_user_settings'>
    {
      !user &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      user &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings' messageList={messageList} titleMessageKey='c_user_settings' />

        <LRTableBodyUI context={context} className='menu'>

          <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_email'
            rightViewUI={<EmailViewUI context={context} messageList={messageList} email={user.email} />}
            updateUI={<EmailUpdateSF context={context} messageList={messageList} email={user.email} onUpdateComplete={onEmailUpdated} />}
          />

          <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_name'
            rightViewUI={<NameViewUI context={context} messageList={messageList} firstName={user.firstName} lastName={user.lastName} />}
            updateUI={<NameUpdateSF context={context} messageList={messageList} firstName={user.firstName} lastName={user.lastName} onUpdateComplete={onNameUpdated} />}
          />

          <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_photo'
            rightViewUI={<AvatarViewUI context={context} messageList={messageList} avatarUrl={user.avatarUrl} />}
            updateUI={<AvatarInfoUI context={context} messageList={messageList} avatarUrl={user.avatarUrl} email={user.email} />}
          />

          <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_password'
            rightViewUI={<PasswordViewUI context={context} messageList={messageList} />}
            updateUI={user.identityProvider ?
              <PasswordExternalUI context={context} messageList={messageList} identityProvider={user.identityProvider} />
              :
              <PasswordUpdateSF context={context} messageList={messageList} />
            }
          />

          {/*
          <LRTableRowUI
            context={context}
            left={<label><MessageUI messageList={messageList} messageKey='c_email_notifications' /></label>}
            right={<EmailAcceptanceUpdateSF context={context} messageList={messageList} emailAcceptance={user.emailAcceptance} onUpdateComplete={onEmailAcceptanceUpdated} />}
          />
          */}

          <LRTableRowLinkUI
            context={context}
            to='/settings/user/teams'
            left={<label><MessageUI messageList={messageList} messageKey='c_connected_accounts' /></label>}
            right={<div className="icon icon-caret-right"></div>}
          />

          <LRTableRowLinkUI
            context={context}
            to='/settings/user/projects'
            left={<label><MessageUI messageList={messageList} messageKey='c_connected_projects' /></label>}
            right={<div className="icon icon-caret-right"></div>}
          />

          <LRTableRowLinkUI
            context={context}
            to='/settings/user/notifications'
            left={<label><MessageUI messageList={messageList} messageKey='c_email_notifications' /></label>}
            right={<div className="icon icon-caret-right"></div>}
          />

        </LRTableBodyUI>
      </div>
    }
  </PrivatePageSF>

export default UserSettingsPrjPageUI
